import React, { useState, useEffect, useCallback } from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import QuestionBox from "./questionbox";
import SpacingBox from "./Spacing";
import HeadingPage from "./Heading";
import { useParams } from "react-router-dom";
import useFetchData from "../fetchpostData";
import Notification from "./Notification";
import ScoreBoxForDoubleAnswer from "./ResponseBoxDoubleType";
import MCQMultiSelect from "./MultiOptionSelect";
import ScoreCardForReading from "./ScoreBoxForReadingSection";
import Timers from "../PageComponent/Timers";

const MultipleDoubleAnswerPage = () => {
  const { title } = useParams();
  const section = "multipletypedoubleanswer";
  const practiceItemId = title;

  const post = useFetchData(section, title);

  const [originalWords, setOriginalWords] = useState("");
  const [Mcq_Question, setMcq_Question] = useState("");
  const [Title, setTitle] = useState("");
  const [paraTitle, setParaTitle] = useState("");
  const [McqOptions, setMcqOptions] = useState([]);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isAttempted, setIsAttempted] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [savedPractice, setSavedPractice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (post && post.question) {
      setOriginalWords(post.question);
      setMcq_Question(post.question_mcq);
      setTitle(post.q_title);
      setParaTitle(post.title);
      setMcqOptions(post.option);
    }
  }, [post]);

  const handleSelectedOptionsChange = useCallback((selected) => {
    console.log("Selected options:", selected);
    setSelectedOptions(selected);
  }, []);

  useEffect(() => {
    console.log("selectedOptions state updated:", selectedOptions);
  }, [selectedOptions]);

  const savePractice = async (practiceData) => {
    try {
      const response = await fetch("/api/save-multipletypedoubleeanswer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(practiceData),
      });

      if (!response.ok) {
        throw new Error("Failed to save practice data");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  const handleFormSubmission = useCallback(async () => {
    const practiceType = section;

    const practiceData = {
      practiceType,
      practiceItemId,
      response: {
        questionId: practiceItemId,
        answer: selectedOptions,
        isAttempted,
      },
    };

    try {
      const result = await savePractice(practiceData);
      setMessage("Practice data saved successfully!");
      console.log("practiceData:", practiceData);

      setNotificationType("success");
      setSavedPractice(result);
      setShowNotification(true);

      setTimeout(() => {
        setIsAttempted(true);
        setLoading(false);
      }, 2000);
    } catch (error) {
      setMessage("Failed to save practice data.");
      setNotificationType("error");
      setShowNotification(true);
      setLoading(false);
    }
  }, [selectedOptions, isAttempted]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitted(true);

    // Wait for the state to be updated before proceeding
    handleFormSubmission();
  };

  const handleRetake = () => {
    setSelectedOptions([]);
    setSubmitted(false);
    setIsAttempted(false);
    setSavedPractice(null);
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  const handleIsAttempted = (isAttemptedValue) => {
    setIsAttempted(isAttemptedValue);
  };

  const attemptedStatus = isAttempted ? "Attempted" : "Not Attempted";

  console.log("savedPractice", savedPractice);

  // console.log('selectedOptions:', selectedOptions);

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <div className="relative md:left-72 left-0 md:ml-3 top-28 bg-gray-100 h-auto w-full md:w-[1150px] rounded-sm p-4 ">
        <HeadingPage
          title="Question"
          timer={<Timers initialSeconds={0} />} // Use the Timer component here
          difficulty="Medium"
          attempted={attemptedStatus}
          para={paraTitle}
        />
        <h3 class="mx-auto px-5 text-base sm:text-lg md:text-xl lg:text-base leading-relaxed">
          Read the text and answer the question by selecting all the correct
          responses. More than one response is correct.
        </h3>
        <QuestionBox question={originalWords} />
        <MCQMultiSelect
          question={Mcq_Question}
          options={McqOptions}
          onOptionSelect={handleSelectedOptionsChange}
          selectedOption={selectedOptions}
          submitted={submitted}
        />

        <div className="flex space-x-4 mt-4">
          <button
            className="bg-blue-800 hover:bg-blue-500 text-white font-semibold py-1 px-4 ml-5 rounded-sm"
            onClick={handleSubmit}
            disabled={submitted}
          >
            <span className="flex items-center justify-center">
              {loading ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  <span>Submitting...</span>
                </>
              ) : (
                "Submit"
              )}
            </span>
          </button>

          {submitted && (
            <button
              type="button"
              onClick={handleRetake}
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-1 px-4 rounded-sm"
            >
              Retake
            </button>
          )}
        </div>

        {submitted ? (
          <>
            <div className="flex items-center justify-center h-72 bg-gray-100">
              <ScoreCardForReading
                score={savedPractice?.totalScore}
                maxScore={savedPractice?.correctOptions}
              />{" "}
            </div>
          </>
        ) : null}

        <ScoreBoxForDoubleAnswer
          originalWords={originalWords}
          practiceItemId={practiceItemId}
          onIsAttempted={handleIsAttempted}
        />

        <SpacingBox />
      </div>

      {showNotification && (
        <Notification
          message={message}
          type={notificationType}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
};

export default MultipleDoubleAnswerPage;
